import { useMutation } from '@tanstack/react-query';
import { forwardQuote } from '../service';

export function useQuoteForward({
    onSuccess = () => {},
    onError = () => {},
}: {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
} = {}) {
    const mutation = useMutation({
        mutationFn: async ({
            quoteId,
            toAddresses,
            ccAddresses,
            message,
            subscribeToNotifications,
        }: {
            quoteId: number;
            toAddresses: string[];
            ccAddresses: string[];
            message: string | null;
            subscribeToNotifications: boolean;
        }) => {
            await forwardQuote(
                quoteId,
                toAddresses,
                ccAddresses,
                message,
                subscribeToNotifications
            );
        },
        onSuccess,
        onError,
    });

    return mutation;
}
